const endpoint = path => `/enterprise/v1/services${path}`;

const services = ({ get }) => ({
  getServices: (params, opts) => get(endpoint(""), params, opts),
  getPricing: (params, opts) => get(`/enterprise/v1/servicePricing/${params.serviceRef}/subscriptions/${params.count}`)
});

export default services;